export default "__VITE_ASSET__GblXj6wl__"